import { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useSetShopDefaultPaymentMethodMutation = createMutationHook(
  PaymentApiClient.setShopDefaultPaymentMethod,
  {
    mutationKey: ['setShopDefaultPaymentMethod'],
  },
)
